<template>
    <div class="web">

        <!-- 搜索 -->
        <div class="search">
            <search :go="true" />
        </div>

        <!-- 广告 -->
        <div class="advertisement">
            <advertisement />
        </div>

        <!-- 急聘职位 -->
        <div class="post" v-loading="Urgentloading">
            <webTitle title="急聘职位"></webTitle>
            <el-row :gutter="10" class="listBox" v-if="urgentEmploymentList.length > 0">
                <el-col :span="8" v-for="(item, index) in urgentEmploymentList" :key="index" class="list">
                    <list :item="item"></list>
                </el-col>
            </el-row>
            <div class="checkMore" v-if="urgentEmploymentList.length > 0">
                <el-button type="primary" size="small" @click="goPost">查看更多</el-button>
            </div>
            <div v-if="urgentEmploymentList.length == 0">
                <noData imgWidth="20%" pad="30px" />
            </div>
        </div>

        <!-- 热招职位 -->
        <div class="post" v-loading="hotJobLoading">
            <webTitle title="热招职位"></webTitle>
            <el-row :gutter="10" class="listBox" v-if="urgentMoveList.length > 0">
                <el-col :span="8" v-for="(item, index) in urgentMoveList" :key="index" class="list">
                    <list :item="item"></list>
                </el-col>
            </el-row>
            <div class="checkMore" v-if="urgentMoveList.length > 0">
                <el-button type="primary" size="small" @click="goPost">查看更多</el-button>
            </div>
            <div v-if="urgentMoveList.length == 0">
                <noData imgWidth="20%" pad="30px" />
            </div>
        </div>

        <!-- 热门园所 -->
        <div class="post" v-loading="hotLoading">
            <webTitle title="热门园所"></webTitle>
            <el-row :gutter="10" class="listBox" v-if="companyList.length > 0">
                <el-col :span="8" v-for="(item, index) in companyList" :key="index" class="list">
                    <div class="schoolBox">
                        <div class="school" @click="goSchoolDetail(item)">
                            <el-avatar size="small" :src="item.school_avatar"></el-avatar>
                            <div class="schoolContent">
                                <div class="school_name">{{item.school_name}}</div>
                                <div class="schoolContentBox">
                                    <span>
                                        {{item.province_name?item.province_name:''}}{{item.city_name?item.city_name:''}}{{item.dist_name?item.dist_name:''}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="postList">
                            <div class="postBox" v-for="(postItem, postIndex) in item.postList.filter((o,i)=>i<3)" :key="postIndex" @click="goDetail">
                                <div class="clearfix">
                                    <div class="fl post_job_name textOverflow">{{postItem.job_name}}</div>
                                    <div class="fr post_salary_package">{{postItem.salary_package}}元/月</div>
                                </div>
                                <div class="post_label">
                                    <span>{{postItem.province_name?postItem.province_name:''}}{{postItem.city_name?postItem.city_name:''}}{{postItem.dist_name?postItem.dist_name:''}}</span>
                                    <span>{{postItem.educational_require}}</span>
                                </div>
                            </div>
                            <div class="morePost" @click="goSchoolDetail(item)">查看更多职位</div>
                        </div> -->
                    </div>
                </el-col>
            </el-row>
            <div class="checkMore" v-if="companyList.length > 0">
                <el-button type="primary" size="small" @click="goPost">查看更多</el-button>
            </div>
            <div v-if="companyList.length == 0">
                <noData imgWidth="20%" pad="30px" />
            </div>
        </div>
    </div>
</template>

<script>
    import search from '@/components/search'
    import advertisement from '@/components/advertisement'
    import webTitle from '@/components/webTitle'
    import list from '@/components/list'
    import noData from '@/components/noData'
    export default {
        components: {
            search,
            advertisement,
            webTitle,
            list,
            noData
        },
        data() {
            return {
                Urgentloading: true,
                hotLoading: true,
                area:{},
                hotJobLoading: true, // 热招职位loading
                urgentEmploymentList: [],
                urgentMoveList: [], // 热招职位
                companyList: [],
                company_typeList: ['幼儿园','早教/托育机构','综合教育公司','其他'],
                scaleList: ["5个班以下","5-10个班","10~15个班","15~20个班","20个班以上"],
                accToken: ''
            }
        },
        mounted() {
            if(this.Cookies.get('AccessToken')) {
                this.accToken = JSON.parse(this.Cookies.get('AccessToken')).access_token
            }
            try {
                this.area = JSON.parse(sessionStorage.getItem('area'))
            } catch (error) {
                sessionStorage.removeItem('area')
            }
            this.getHotJob()
            this.getUrgent()
            this.getSchool()
        },
        methods: {

            // 去职位列表
            goPost() {
                this.$router.push({ path:'/job/post' })
            },

            // 去职位详情
            goDetail() {
                this.$router.push({
                    path:'/job/postDetail'
                })
            },

            // 获取热招职位
            getHotJob() {
                let obj = {
                    sort: 'active',
                    page: 1,
                    size: 6,
                    area: this.area,
                    condition: {},
                    require: {}
                }
                this.hotJobLoading = true
                this.api.post('/5cefadba19924', obj).then(r => {
                    this.hotJobLoading = false
                    this.urgentMoveList = r.data.list
                    this.urgentMoveList.forEach(o=>{
                        try {
                            o.educational_require = JSON.parse(o.educational_require)[0]
                        } catch (error) {
                            o.educational_require = o.educational_require
                        }
                    })
                })
            },

            // 获取急聘职位
            getUrgent() {
                let obj = {
                    sort: 'home_hot',
                    page: 1,
                    size: 6,
                    area: this.area,
                    condition: {},
                    require: {}
                }
                this.Urgentloading = true
                this.api.post('/5cefadba19924', obj).then(r => {
                    this.Urgentloading = false
                    this.urgentEmploymentList = r.data.list
                    this.urgentEmploymentList.forEach(o=>{
                        try {
                            o.educational_require = JSON.parse(o.educational_require)[0]
                        } catch (error) {
                            o.educational_require = o.educational_require
                        }
                    })
                })
            },

            // 去园所详情
            goSchoolDetail(o) {
                this.$router.push({
                    path: '/job/schoolDetail',
                    query: {
                        sid: o.sid
                    }
                })
            },

            // 获取热门园所
            getSchool() {
                this.hotLoading = true
                let obj = {
                    area: this.area,
                    page: 1,
                    size: 6,
                    sort: 'home_hot'
                }
                this.api.post('/5cfe5ef6207fe', obj).then(r => {
                    this.hotLoading = false
                    this.companyList = r.data.list
                })
            },

        }
    }
</script>

<style lang="scss" scoped>
.web {

    .search {
        width: 934px;
        margin: 0 auto;
        padding-top: 20px;
    }
    .advertisement {
        padding-top: 30px;
    }
    .post {
        padding-top: 37px;
        .listBox {
            padding-top: 20px;
            .list {
                margin-top: 10px;
            }
            .list:nth-child(1),.list:nth-child(2),.list:nth-child(3) {
                margin-top: 0;
            }
            
            .schoolBox {
                transition: all .5s;
                background: white;
                padding: 16px 20px;
                cursor: pointer;
                height: 42px;
                .school {
                    .schoolContent {
                        display: inline-block;
                        vertical-align: middle;
                        margin-left: 20px;
                    }
                    .schoolContentBox {
                        color: #8d92a1;
                        font-size: 12px;
                        padding-top: 5px;
                    }
                    >span {
                        display: inline-block;
                        vertical-align: middle;
                    }
                }
            }
            .schoolBox:hover {
                box-shadow: 5px 5px 20px rgba(0,0,0,.05);
            }
            .school:hover {
                .school_name {
                    color: #ff5b12;
                }
            }
            .postBox:hover {
                .post_job_name {
                    color: #ff5b12;
                }
            }
            .postBox {
                border-top: 1px solid #eef0f5;
                padding: 16px 0;
                .post_job_name {
                    width: 50%;
                }
                .post_salary_package {
                    color: #fd7240;
                }
                .post_label {
                    padding-top: 12px;
                    >span {
                        color: #8d92a1;
                        padding: 4px 10px;
                        font-size: 12px;
                        border-radius: 3px;
                        background-color: #f8f9fc;
                    }
                }
            }
            .morePost {
                text-align: center;
                border: 1px solid #fd7240;
                width: 50%;
                margin: 0 auto;
                color: #fd7240;
                font-size: 14px;
                padding: 5px 0;
            }
            .morePost:hover {
                background: #fd7240;
                color: white;
            }
            .postBox:first-child {
                border-top: none;
            }
        }
        .checkMore {
            text-align: center;
            padding-top: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/job/index.vue